export const CHART_TYPES = [
  {
    value: 'table',
    label: '表格'
  },
  {
    value: 'bar',
    label: '柱状图'
  },
  {
    value: 'line',
    label: '折线图'
  },
  {
    value: 'pie',
    label: '饼图'
  },
  {
    value: 'deviceTopBar',
    label: '设备TOP柱状图'
  },
  {
    value: 'YieldLine',
    label: '设备班次产量/报警统计'
  },
  {
    value: 'multichart',
    label: '分页图表'
  },
  {
    value: 'gauge',
    label: '仪表盘'
  },
  {
    value: 'devicePie',
    label: '自定义饼图'
  },
  {
    value: 'GanttChart',
    label: '甘特图'
  },
  {
    value: 'deviceStatus',
    label: '设备状态'
  },
  {
    value: 'runningTimeBar',
    label: '运行时长柱状图'
  },
  {
    value: 'runningTimeAbo',
    label: '平均运行时长'
  },
  {
    value: 'runningTimeDiv',
    label: '设备运行时长'
  }
]

export const INTERFACE_METHODS = [
  {
    value: 0,
    label: 'POST'
  },
  {
    value: 1,
    label: 'PUT'
  },
  {
    value: 2,
    label: 'GET'
  }]

  export const REQUIRED_LIST = [
    {
      value: 1,
      label: '是'
    },
    {
      value: 0,
      label: '否'
    }
  ]

  export const DATA_TYPES = [
    {
      value: 0,
      label: '文本',
    },
    {
      value: 1,
      label: '数值'
    },
    {
      value: 2,
      label: '下拉'
    },
    {
      value: 3,
      label: '日期'
    },
    {
      value: 4,
      label: '树选择'
    }
  ]
